// Déplace le bloc "description" (actuellement seul contenu positionné sous
// la colonne d'achat) pour qu'il s'affiche pleine largeur SOUS les deux
// colonnes (galerie + achat), conformément à la nouvelle maquette — au lieu
// de rester empilé dans la colonne d'achat comme le fait Dawn nativement.
//
// Cantonné à l'ordinateur (≥1024px) uniquement : en dessous de ce seuil, le
// bloc est remis exactement à sa position d'origine (repère par un noeud de
// commentaire), donc aucun effet sur tablette/mobile, qui gardent le
// comportement actuel inchangé à ce stade.
//
// Pure repositionnement DOM : aucune donnée, aucun texte, aucune fonction
// (accordéon, avis, etc.) n'est modifiée — seul l'emplacement visuel change.
(function () {
  if (window.__pdpLayoutInit) return;
  window.__pdpLayoutInit = true;

  var desktopQuery = window.matchMedia('(min-width: 1024px)');
  var marker = document.createComment('pdp-description-original-position');
  var moved = false;

  function moveOut() {
    if (moved) return;
    var grid = document.querySelector('[id$="__main"].shopify-section .product.grid');
    var panel = document.querySelector('[id$="__main"].shopify-section .product-description-premium');
    if (!grid || !panel) return;

    panel.parentNode.insertBefore(marker, panel);
    panel.classList.add('pdp-full-width-panel');
    grid.parentNode.insertBefore(panel, grid.nextSibling);
    moved = true;
  }

  function moveBack() {
    if (!moved) return;
    var panel = document.querySelector('[id$="__main"].shopify-section .pdp-full-width-panel');
    if (panel && marker.parentNode) {
      panel.classList.remove('pdp-full-width-panel');
      marker.parentNode.insertBefore(panel, marker);
    }
    if (marker.parentNode) marker.parentNode.removeChild(marker);
    moved = false;
  }

  function sync() {
    if (desktopQuery.matches) {
      moveOut();
    } else {
      moveBack();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  desktopQuery.addEventListener('change', sync);
})();
